import React from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaTiktok,
  FaFacebook,
} from "react-icons/fa";
import "./Footer.css";


function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="tv-footer">

      {/* =====================================================
          FOOTER MAIN
      ===================================================== */}

      <div className="tv-footer-main">

        <div className="tv-footer-container">

          {/* BRAND */}
          <div className="tv-footer-brand">

            <Link to="/" className="tv-footer-logo">
              <img
                src="/images/logo.png"
                alt="Time Valley Watches"
              />
            </Link>

            <p>
              Timeless timepieces designed for those who
              appreciate refined design, enduring character
              and the art of time.
            </p>

<div className="tv-footer-socials">

  <a
    href="https://www.instagram.com/time._valley/"
    aria-label="Instagram"
    className="tv-footer-social"
  >
    <FaInstagram />
  </a>

  <a
    href="https://www.tiktok.com/@time._valley?_r=1&_t=ZP-9AFBmFcFtVv"
    aria-label="TikTok"
    className="tv-footer-social"
  >
    <FaTiktok />
  </a>

  <a
    href="https://www.facebook.com/share/1LqZQxKVar/"
    aria-label="Pinterest"
    className="tv-footer-social"
  >
    <FaFacebook />
  </a>

</div>


          </div>


          {/* SHOP */}
          <div className="tv-footer-column">

            <h3>Shop</h3>

            <ul>
              <li>
                <Link to="/shop">All Watches</Link>
              </li>

              <li>
                <Link to="/shop">Men's Watches</Link>
              </li>

              <li>
                <Link to="/collections">Collections</Link>
              </li>

              {/* <li>
                <Link to="/shop?sort=newest">
                  New Arrivals
                </Link>
              </li>

              <li>
                <Link to="/shop?featured=true">
                  Best Sellers
                </Link>
              </li> */}
            </ul>

          </div>


          {/* COLLECTIONS */}
          <div className="tv-footer-column">

            <h3>Collections</h3>

            <ul>
              <li>
                <Link to="/collections">
                  Premium
                </Link>
              </li>

              <li>
                <Link to="/collections">
                  Classic
                </Link>
              </li>

              <li>
                <Link to="/collections">
                  Essential
                </Link>
              </li>

              {/* <li>
                <Link to="/collections/prestige">
                  Prestige
                </Link>
              </li> */}
            </ul>

          </div>


          {/* COMPANY */}
          <div className="tv-footer-column">

            <h3>Company</h3>

            <ul>
              <li>
                <Link to="/about">Our Story</Link>
              </li>

              <li>
                <Link to="/contact">Contact Us</Link>
              </li>

              <li>
                <Link to="/faq">FAQ</Link>
              </li>

              <li>
                {/* <Link to="/shipping">
                  Shipping & Delivery
                </Link> */}
              </li>

              <li>
                {/* <Link to="/returns">
                  Returns & Exchanges
                </Link> */}
              </li>
            </ul>

          </div>


          {/* CONTACT */}
          <div className="tv-footer-column tv-footer-contact">

            <h3>Get In Touch</h3>

            <div className="tv-footer-contact-item">

              <span className="tv-footer-contact-label">
                Email
              </span>

              <a href="mailto:infotimevalley@gmail.com">
                infotimevalley@gmail.com
              </a>
<span className="tv-footer-contact-label">
                Email TO Company
              </span>
              <a href="mailto:khadamsons786@gmail.com">
                khadamsons786@gmail.com
              </a>

            </div>

            <div className="tv-footer-contact-item">

              <span className="tv-footer-contact-label">
                Phone
              </span>

              <a href="tel:03249320453">
                +92 324 9320453
              </a>

            </div>

            <div className="tv-footer-contact-item">

              <span className="tv-footer-contact-label">
                Hours
              </span>

              <span>
                Mon — Sat
                <br />
                9:00AM — 10:00PM
              </span>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          FOOTER BOTTOM
      ===================================================== */}

      <div className="tv-footer-bottom">

        <div className="tv-footer-bottom-container">

          <p>
            © {currentYear} Time Valley Watches.
            All rights reserved.
          </p>

          <div className="tv-footer-legal">

            <Link to="/privacy">
              Privacy Policy
            </Link>

            <span></span>

            <Link to="/terms">
              Terms & Conditions
            </Link>

          </div>

          <div className="tv-footer-made">
            <span>CRAFTED FOR TIME</span>
          </div>

        </div>

      </div>

    </footer>
  );
}

export default Footer;
